import { render, staticRenderFns } from "./TopEntityComponentWorkHours.vue?vue&type=template&id=2b7834da&"
import script from "./TopEntityComponentWorkHours.vue?vue&type=script&lang=js&"
export * from "./TopEntityComponentWorkHours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WorkTime: require('/srv/rir-platform/tourism/src/tourism-front/components/common/WorkTime/index.vue').default})
